import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { TUserRoles } from '@/features/users/schemas/users.schema.ts';

interface AuthStore {
  refreshToken: {
    expiresAt: number | undefined;
  };
  setTokenExpiration: (unixDate: number) => void;
  isAuthenticated: boolean;
  setIsAuthenticated: (bool: boolean) => void;
  role: TUserRoles;
  setUserRole: (role: TUserRoles) => void;
  userId: string | undefined;
  setUserId: (userId: string) => void;
  reset: () => void;
}

const initialState = {
  refreshToken: { expiresAt: undefined },
  isAuthenticated: false,
  role: 'Unknown' as TUserRoles,
  userId: undefined,
};

export const useAuthStore = create<AuthStore>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        setTokenExpiration: (unixDate) =>
          set(() => ({
            refreshToken: { expiresAt: Number(unixDate) },
          })),
        setIsAuthenticated: (bool) => set(() => ({ isAuthenticated: bool })),
        setUserRole: (role: TUserRoles) => set(() => ({ role })),
        setUserId: (userId: string) => set(() => ({ userId })),
        reset: () => set(() => ({ ...initialState })),
      }),
      { name: 'ems-auth-store' }
    )
  )
);

export const clearAuthStore = () => {
  useAuthStore.getState().reset();
  useAuthStore.persist.clearStorage();
};
